import Vue from 'vue'
import VueRouter from 'vue-router'
import vbclass from 'vue-body-class'

import $ from 'jquery'
import jQuery from 'jquery'

import {store} from './assets/js/store.js'
import App from './App.vue'

import './assets/css/normalize.css'
import './assets/css/app.scss'
import 'font-awesome/scss/font-awesome.scss'
import vmodal from 'vue-js-modal'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

Vue.use(VueRouter);
Vue.component('sync-loader',SyncLoader);
Vue.use(vmodal);

import SelectCategory from './components/SelectCategory.vue'
import Exam from './components/Exam.vue'
import QuestionRemark from './components/QuestionRemark.vue'
import Results from './components/Results.vue'
import SubmitRequirements from './components/SubmitRequirements.vue'
import FinishExam from "./components/FinishExam";

const routes = [
  { name: 'home', path: '/', meta: { bodyClass: 'default' }, component: SelectCategory },
  { name: 'exam', path: '/exam/:uid', meta: { bodyClass: 'tasks' }, component: Exam },
  { name: 'finish-exam', path: '/finish-exam', meta: { bodyClass: 'tasks finished' }, component: FinishExam },
  { name: 'results', path: '/results/:uid', meta: { bodyClass: 'tasks finished' }, component: Results },
  { name: 'teilnahmebedingungen', path: '/teilnahmebedingungen', meta: { bodyClass: 'default' }, component: SubmitRequirements }
];

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0  }
  }
});

Vue.use( vbclass, router );

new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
});

import './assets/js/custom.js'

$('select[name=stufe]').select2Buttons({noDefault: true});
$('select[name=fach]').select2Buttons({noDefault: true});



// WEBPACK FOOTER //
// ./src/main.js